import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../../utils/api";
import { useAuthorization } from "../../authorization/useAuthorization";
import { AuthorizationErrorMessage } from "../../authorization/AuthorizationErrorMessage";
import { ErrorMessage } from "../../authorization/ErrorMessage";
import type z from "zod";
import { schemas } from "../../api/generated";

type File = z.infer<typeof schemas.File>;

const UserEdit = () => {
  const { userId } = useParams();
  const auth = useAuthorization({
    userTypes: ["Admin", "User"],
    resourceUserId: userId || "",
  });
  const [files, setFiles] = useState<File[]>([]);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (auth.authorized && userId) {
      const fetchFiles = async () => {
        try {
          const response = await api.getUserFiles(auth.token, userId);
          setErrorMessage("");
          setFiles(response.files);
        } catch {
          setErrorMessage("Failed to fetch user files.");
          setFiles([]);
        }
      };
      fetchFiles();
    }
  }, [auth, userId]);

  if (!auth.authorized) {
    return <AuthorizationErrorMessage {...auth} />;
  } else if (errorMessage) {
    return <ErrorMessage message={errorMessage} />;
  }

  return (
    <div className="my-md-3 my-1">
      <h2>Edit User</h2>
      {files.length === 0 ? (
        <p>No files available</p>
      ) : (
        <ul>
          {files.map((file, index) => (
            <li key={index}>
              <a href={`/file-download/${file.fileName}`}>{file.fileName}</a>
              <input type="file" />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default UserEdit;
